import React, { useEffect, useState } from 'react'

import lang from '@/lang'
import { ConfirmModal } from '@/modules/base/components/modal'

interface ReceiptApplyDataModalInterface {
  fileToCheck: any
  preventReset?: boolean
  swapButtons?: boolean
  contactFormEnabled?: boolean
  dateFor?: string
  cancelLabel?: string
  confirmLabel?: string
  descriptionLabel?: string
  titleLabel?: string
  onCancel?: () => void
  onPanic?: () => void
  onApplyData?: (ocrData: any) => void
}

export const ReceiptApplyDataModal = (props: ReceiptApplyDataModalInterface) => {
  const {
    fileToCheck,
    preventReset,
    onCancel,
    onPanic,
    onApplyData,
    cancelLabel,
    confirmLabel,
    descriptionLabel,
    titleLabel,
    swapButtons = false,
  } = props
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const ocrData = fileToCheck?.metaData?.ocr
    if (ocrData) { // has ocr data
      if (!preventReset) {
        onApplyData?.({ filledData: [] })
      }
      setOpen(true)
    }
  }, [fileToCheck])

  const onAbort = () => {
    setOpen(false)
    onCancel?.()
  }

  const onConfirm = async() => {
    onApplyData?.()
    setOpen(false)
  }

  const {
    documents: {
      applyDataModal,
    },
  } = lang

  return (
    <ConfirmModal
      open={open}
      title={titleLabel ?? applyDataModal.titleApply}
      description={descriptionLabel ?? applyDataModal.descriptionApply}
      onConfirm={swapButtons ? onAbort : onConfirm}
      onAbort={swapButtons ? onConfirm : onAbort}
      onPanic={onPanic}
      confirmButtonLabel={confirmLabel ?? applyDataModal.confirmYes}
      abortButtonLabel={cancelLabel ?? applyDataModal.cancel }
    />
  )
}

export default ReceiptApplyDataModal
